const COLD = 0
const WARM = 1
const HOT = 2
const SUCCES = 3

export const STATUS_POTENTIAL_COLOR = {
  [COLD]: "#004AD1",
  [WARM]: "#FF961C",
  [HOT]: "#E40139",
  [SUCCES]: "#30D59B",
}
